import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import SvgIcon from '../Icons/SvgIcon';

var IconOn = function IconOn(props) {
  return _jsx(SvgIcon, __assign({}, props, {
    width: 18,
    height: 18
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 0C1.34315 0 0 1.34315 0 3V15C0 16.6569 1.34315 18 3 18H15C16.6569 18 18 16.6569 18 15V3C18 1.34315 16.6569 0 15 0H3ZM14.1364 6.43791C14.4879 6.08644 14.4879 5.51659 14.1364 5.16512C13.7849 4.81365 13.2151 4.81365 12.8636 5.16512L7.26627 10.7624L5.09924 8.82862C4.72837 8.49767 4.15945 8.53003 3.8285 8.90089C3.49755 9.27175 3.5299 9.84068 3.90076 10.1716L6.7022 12.6716C7.05825 12.9893 7.6004 12.9739 7.93783 12.6365L14.1364 6.43791Z"
    })
  }));
};

export default IconOn;